/**
 * Product Swatch Background Loader
 * Automatically applies data-style contents to swatch elements
 * Handles both initial load and dynamic content updates
 */

(function () {
  function applySwatchBackgrounds(context = document) {
    const swatches = context.querySelectorAll('.lazybg[data-style]');

    swatches.forEach((el, index) => {
      const ds = el.getAttribute('data-style');
      if (!ds) return;

      // Preserva outras propriedades inline (se houver) enquanto garante o background correto
      const current = el.getAttribute('style') || '';
      const cleaned = current
        .split(';')
        .filter(s => s.trim() && !/^background(-image)?\s*:/.test(s.trim()))
        .join('; ');

      el.setAttribute('style', `${cleaned ? cleaned + '; ' : ''}${ds}`);
      el.classList.add('swatch-loaded');
    });
  }

  function reapply() {
    applySwatchBackgrounds(document);
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', reapply);

  // Handle Shopify dynamic content loading
  document.addEventListener('shopify:section:load', (e) => {
    applySwatchBackgrounds(e.target || document);
  });

  /* // Handle variant changes
  document.addEventListener('variant:change', () => {
    reapply();
  }); */

  // Handle cart drawer opening
  document.addEventListener('cart:open', () => {
    reapply();
  });

  // Sync swatch with select
  document.addEventListener('DOMContentLoaded', () => {
    // Handle both single product and multi-product selects
    const selects = document.querySelectorAll('#ProductSelect, #all-product-variants, [id^="all-product-variants-"]');
    if (!selects || selects.length === 0) return;

    /* selects.forEach(select => {
      function syncSwatchWithSelect() {
        const selected = select.options[select.selectedIndex];
        
        if (!selected) return;
        
        // If selected variant is not available, find and select first available
        if (selected.dataset.available !== 'true') {
          const options = Array.from(select.options);
          const firstAvailable = options.find((opt) => opt.value && opt.dataset.available === 'true');

          if (firstAvailable) {
            select.value = firstAvailable.value;
            const opts = (firstAvailable.dataset.options || '').split(',');
            
            // Get the product container to scope swatch selection
            const productContainer = select.closest('.highlight-product__buy-box, .product-form');
            const bundleContainer = select.closest('.bundle-product-item');
            const radios = productContainer 
              ? productContainer.querySelectorAll('.swatch-variant-value')
              : bundleContainer 
                ? bundleContainer.querySelectorAll('.swatch-variant-value')
                : document.querySelectorAll('.swatch-variant-value');

            // Uncheck all radios first
            radios.forEach(r => r.checked = false);
            
            // Check radios that match the available variant options
            radios.forEach(r => {
              if (opts.includes(r.value.trim())) {
                r.checked = true;
              }
            });
            
            select.dispatchEvent(new Event('change', { bubbles: true }));

            return;
          }
        }
        
        // Normal sync when variant is available
        const opts = (selected?.dataset?.options || '').split(',');
        
        // Get the product container to scope swatch selection
        const productContainer = select.closest('.highlight-product__buy-box, .product-form');
        const bundleContainer = select.closest('.bundle-product-item');
        const radios = productContainer 
          ? productContainer.querySelectorAll('.swatch-variant-value')
          : bundleContainer 
            ? bundleContainer.querySelectorAll('.swatch-variant-value')
            : document.querySelectorAll('.swatch-variant-value');
        
        // Uncheck all radios first
        radios.forEach(r => r.checked = false);
        
        // Check radios that match the selected variant options
        radios.forEach(r => {
          if (opts.includes(r.value.trim())) {
            r.checked = true;
          }
        });
      }

      // Run sync after a delay to ensure DOM is ready
      setTimeout(() => {
        syncSwatchWithSelect();
      }, 150);
      
      select.addEventListener('change', syncSwatchWithSelect);
    }); */
  });

  // Fallback: Run periodically to catch any missed swatches
  setInterval(() => {
    const unloadedSwatches = document.querySelectorAll('.lazybg[data-style]:not(.swatch-loaded)');
    if (unloadedSwatches.length > 0) {
      applySwatchBackgrounds();
    }
  }, 2000);

  // Global function for manual triggering
  window.applySwatchBackgrounds = function (context = document) {
    applySwatchBackgrounds(context);
  };
})();